/* import __COLOCATED_TEMPLATE__ from './change-conversation-priority.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Args: {
    action: $TSFixMe;
    actionEditorContext?: { isRulePage?: boolean };
    onChange?: () => void;
    onDelete?: () => void;
    isDisabled?: boolean;
    forceInvalid?: boolean;
  };
}

// Macro-editor action block for "Change priority".
//
// Flag ON:  delegates entirely to Rules::Actions::ChangeConversationPriority,
//           which renders the full five-level IcSelect picker.
// Flag OFF: renders the original legacy read-only macro IcFilterBlock (blank
//           name, details, non-clickable) so flag-off behaviour is unchanged.
//
// The split is necessary because the shared rules component's flag-off
// non-rule-page branch renders rules-specific copy ("Mark as priority"),
// which differs from the macro-specific presentation (blank name + details).
export default class MacrosEditorChangeConversationPriority extends Component<Signature> {
  // Settings → Macros spans both Inbox and non-Inbox UI (see priority-levels
  // discoveries doc), so appService (not session) is the correct flag check
  // per the Ember skill service-boundaries guidance.
  @service declare appService: AppService;

  get isMultiLevelEnabled() {
    return this.appService.app.canUseFeature('team-inbox-priority-levels');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Macros::Editor::ChangeConversationPriority': typeof MacrosEditorChangeConversationPriority;
  }
}
